import './archive-edit-screen.scss'

import { defineComponent } from 'vue';
import { faCheck, faEdit, faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { ArchiveResource } from '@skinsoft/types';
import { archiveRecordMask } from '@skinsoft/record-mask-configs';

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { SAVE_GENERIC_EDIT_SCREEN } from '@skinsoft/bus';
import { GenericEditScreen } from '../../generic/generic-edit-screen';
import { EntityEditScreenController } from '@skinsoft/view-controller';
import { ArchiveDataStore } from '@skinsoft/entity';
import { ArchiveEditScreenHeader } from '@skinsoft/entity-ui/src/archive';

export const ArchiveEditScreen = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sGenericEditScreen: GenericEditScreen,
        sArchiveEditScreenHeader: ArchiveEditScreenHeader,
    },
    props: {
        archiveId: {
            type: String
        },
        headerTitle: {
            type: String,
        },
        navigateBackRoute: {
            type: String
        },
    },
    template: require('./archive-edit-screen.html'),
    data() {
        return {
            recordMasks: [archiveRecordMask],
            // @ts-ignore
            viewController: null as EntityEditScreenController<ArchiveResource> | null,

            canEdit: true,
            forceReadonly: true,
        }
    },
    computed: {
        isReady() {
            return this.viewController !== null
        },
        isMainButtonClickable() {
            return this.canEdit || this.forceReadonly
        },
        buttonLabel() {
            return this.forceReadonly ?
                this.$t('editItemScreen.editButton') : this.$t('editItemScreen.confirmButton')
        },
        buttonIcon() {
            if(this.isMainButtonClickable) {
                return this.forceReadonly ?
                    faEdit : faCheck
            } else {
                return faCircleNotch
            }
        },
        buttonColor() {
            return this.forceReadonly ?
                "" : "validate-color"
        },
    },
    methods: {
        onMainButtonClick() {
            if(this.canEdit) {
                this.forceReadonly = !this.forceReadonly;
                if(this.forceReadonly){
                    this.emitOnBus(SAVE_GENERIC_EDIT_SCREEN)
                }
            } else if(this.forceReadonly) {
                this.forceReadonly = !this.forceReadonly
            }
        },
    },
    mounted() {
        const dataStore = ArchiveDataStore.getInstance()
        // @ts-ignore
        this.viewController = new EntityEditScreenController<ArchiveResource>(dataStore)
    },
})
